module.exports = __webpack_public_path__ + "static/media/shower rain 09d.4ccad051.png";